<template>
  <div class="header-control-card">
    <div class="left-info">
      <div class="status-indicator">
        <span class="pulse-dot"></span>
      </div>
      <div class="view-mode">
        <span class="label-bold">CHẾ ĐỘ XEM</span>
        <span class="range-text">{{ rangeLabel }}</span>
      </div>
    </div>

    <div class="right-actions">
      <span class="select-label">Chọn phạm vi:</span>
      <el-dropdown trigger="click" @command="handleCommand">
        <el-button class="range-dropdown-btn">
          <i :class="currentOption.icon" class="btn-icon"></i>
          <span class="ml-2">{{ currentOption.label }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>

        <el-dropdown-menu slot="dropdown" class="analytics-range-menu">
          <el-dropdown-item
            v-for="item in rangeOptions"
            :key="item.value"
            :command="item.value"
            :class="{ active: currentRange === item.value }"
          >
            <i :class="item.icon" class="item-icon"></i>
            <span>{{ item.label }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export const RANGE_TYPES = [
  'realtime',
  'today',
  '7days',
  '30days',
  '90days',
  'this_month',
  'this_year',
  'all'
]

export const RANGE_OPTIONS = [
  { label: 'Realtime (30 phút)', value: 'realtime', icon: 'fas fa-bolt icon-orange' },
  { label: 'Hôm nay', value: 'today', icon: 'far fa-clock icon-blue' },
  { label: '7 ngày qua', value: '7days', icon: 'far fa-calendar-alt icon-amber' },
  { label: '30 ngày qua', value: '30days', icon: 'far fa-calendar-alt icon-amber' },
  { label: '90 ngày qua', value: '90days', icon: 'far fa-calendar-alt icon-amber' },
  { label: 'Tháng này', value: 'this_month', icon: 'far fa-calendar icon-purple' },
  { label: 'Năm nay', value: 'this_year', icon: 'far fa-calendar-check icon-purple' },
  { label: 'Tất cả', value: 'all', icon: 'fas fa-globe icon-pink' }
]

export default {
  name: 'HeaderControl',
  props: {
    currentRange: {
      type: String,
      default: 'realtime'
    },
    rangeLabel: {
      type: String,
      default: '30 phút qua'
    }
  },
  data() {
    return {
      rangeOptions: RANGE_OPTIONS
    }
  },
  computed: {
    currentOption() {
      return (
        this.rangeOptions.find((opt) => opt.value === this.currentRange) ||
        this.rangeOptions[0]
      )
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('select-range', command)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-control-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f3f5;
  margin-bottom: 20px;

  .left-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .status-indicator {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #e6f7f0;
      display: flex;
      align-items: center;
      justify-content: center;

      .pulse-dot {
        width: 10px;
        height: 10px;
        background-color: #10b981;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5);
        animation: pulse 1.8s infinite;
      }
    }

    .view-mode {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 15px;

      .label-bold {
        font-weight: 800;
        color: #1f2937;
        letter-spacing: 0.3px;
      }

      .range-text {
        color: #6b7280;
        font-weight: 500;
      }
    }
  }

  .right-actions {
    display: flex;
    align-items: center;
    gap: 12px;

    .select-label {
      font-size: 14px;
      font-weight: 600;
      color: #374151;
    }

    .range-dropdown-btn {
      background: #fdfbf7;
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 10px 18px;
      font-size: 14px;
      font-weight: 600;
      color: #1f2937;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.2s ease;

      &:hover {
        border-color: #d1d5db;
        background: #f8f6f0;
      }

      .btn-icon {
        color: #f59e0b;
        font-size: 14px;
      }
    }
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}
</style>

<style lang="scss">
.analytics-range-menu {
  border-radius: 16px !important;
  padding: 8px !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #f3f4f6 !important;
  min-width: 200px !important;

  .el-dropdown-menu__item {
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    display: flex;
    align-items: center;
    gap: 10px;

    &:hover {
      background-color: #f9fafb;
      color: #111827;
    }

    &.active {
      background-color: #f3f4f6;
      font-weight: 700;
    }

    .item-icon {
      font-size: 14px;
      width: 16px;
      text-align: center;
    }

    .icon-orange { color: #f59e0b; }
    .icon-blue { color: #3b82f6; }
    .icon-purple { color: #8b5cf6; }
    .icon-amber { color: #d97706; }
    .icon-pink { color: #ec4899; }
  }
}
</style>
